<template>
  <div class="cd-manage-table">
    <div class="address-container">
      <div class="card-header-container">
        <div class="sac__font-16 f-white semi-bold">
          Service Address
        </div>
      </div>
      <div class="card-body-container">
        <div
          v-for="(item, idx) in serviceAddress"
          :key="idx"
          class="margin-top-16"
        >
          <div class="grid-column jc-b divider-h">
            <div class="sac__font-16 n60 med">
              Address #{{ idx + 1 }}
            </div>
            <div
              class="sac__font-16 f-primary bold clickable"
              @click="toggleAddressModal('edit-address', item, 'SERVICE')"
            >
              Edit
            </div>
          </div>
          <div class="sac__font-16 med margin-top-8">
            <div>
              {{ item.address1 }}
            </div>
            <div>
              {{ item.address2 }}
            </div>
            <div>{{ item.city }}, {{ item.state }} {{ item.zip }} {{ item.country }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="address-container">
      <div class="card-header-container">
        <div class="sac__font-16 f-white semi-bold">
          Shipping Address
        </div>
      </div>
      <div class="card-body-container">
        <div
          v-for="(item, idx) in shippingAddress"
          :key="idx"
          class="margin-top-16"
        >
          <div class="grid-column jc-b divider-h">
            <div class="sac__font-16 n60 med ">
              Address #{{ idx + 1 }}
            </div>
            <div
              class="sac__font-16 f-primary bold clickable"
              @click="toggleAddressModal('edit-address', item, 'SHIPPING')"
            >
              Edit
            </div>
          </div>
          <div class="sac__font-16 med margin-top-8">
            <div>
              {{ item.address1 }}
            </div>
            <div>
              {{ item.address2 }}
            </div>
            <div>{{ item.city }}, {{ item.state }} {{ item.zip }} {{ item.country }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="address-container">
      <div class="card-header-container">
        <div class="sac__font-16 f-white semi-bold">
          Billing Address
        </div>
      </div>
      <div class="card-body-container">
        <div
          class="grid-column jc-b margin-top-16"
        >
          <div class="sac__font-16 med">
            <div>
              {{ billingAddress.address1 }}
            </div>
            <div>
              {{ billingAddress.address2 }}
            </div>
            <div>
              {{ billingAddress.city }},
              {{ billingAddress.state }}
              {{ billingAddress.zip }}
              {{ billingAddress.country }}
            </div>
          </div>
          <div
            class="sac__font-16 f-primary bold clickable"
            @click="toggleAddressModal('edit-address', billingAddress, 'BILLING')"
          >
            Edit
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex';

export default {
  name: 'ManageAddress',
  computed: {
    ...mapState({
      serviceAddress: (state) => state.customerDetail.customer.serviceAddress || [],
      billingAddress: (state) => state.customerDetail.customer.billingAddress || {},
      shippingAddress: (state) => state.customerDetail.customer.shippingAddresses || [],
    }),
  },
  methods: {
    toggleAddressModal(view, item, type) {
      const changes = [{
        field: 'showActionModal',
        value: true,
      }, {
        field: 'actionModalView',
        value: view,
      }, {
        field: 'memberAddress',
        value: { ...item, type },
      }];
      this.$store.dispatch('changeCustomerDetailValues', changes);
    },
  },
};
</script>

<style scoped lang="scss">

.cd-manage-table {
  display: grid;
  width: 100%;
  grid-template-columns: repeat(auto-fill, minmax(min(20rem, 100%), 1fr));
  justify-content: space-between;
  gap: 24px;
  .address-container {
    .card-header-container {
      border-top-left-radius: 12px;
      border-top-right-radius: 12px;
      padding: 0 16px;
      background-color: $CONTENTGRAY;
      height: 56px;
      justify-content: space-between;
      display: flex;
      align-items: center;
    }
    .card-body-container {
      background-color: $WHITE;
      border-bottom-left-radius: 12px;
      border-bottom-right-radius: 12px;
      padding: 16px;
    }
  }
  .margin-top-16 {
    &:first-child {
      margin-top: unset;
    }
  }
}

</style>
